import { getDateFormatted, getJSDate } from '@shared/utils';
import { useMemo } from 'react';
import { ScheduleDay } from '../schedule/components/schedule-day';
import {
  NoDigitalSlot,
  NoDigitalDaySlot,
  NoDigitalSingleSchedule,
  NoDigitalSchedule
} from './types';

export const useNoDigitalSchedule = (slots: NoDigitalSlot[]): NoDigitalSchedule => {
  const splitArray = (array: { day: JSX.Element; daySlots: NoDigitalDaySlot[] }[]): NoDigitalSchedule => {
    const WEEK_DAYS = 7;
    const result: NoDigitalSchedule = [];
    let currentSubarray: { day: JSX.Element; daySlots: NoDigitalDaySlot[] }[] = [];

    for (let i = 0; i < array.length; i++) {
      if (currentSubarray.length < WEEK_DAYS) {
        currentSubarray.push(array[i]);
      } else {
        result.push([...currentSubarray]);
        currentSubarray = [array[i]];
      }
    }

    if (currentSubarray.length > 0) {
      result.push([...currentSubarray]);
    }

    return result;
  };

  const getWorkDays = (slots: NoDigitalSlot[]): string[] => {
    const workDays: string[] = [];

    slots.forEach((slot) => {
      const startDate = slot.start || slot.effective_start;
      if (!startDate) return;

      const date = getDateFormatted(startDate, 'DD/MM/YYYY').toString();

      if (!workDays.includes(date)) {
        workDays.push(date);
      }
    });

    return workDays;
  };

  const getDaySlots = (slots: NoDigitalSlot[], day: string): NoDigitalDaySlot[] => {
    const daySlots: NoDigitalDaySlot[] = [];
   

 
    slots.forEach((slot) => {
      const startDate = slot.start || slot.effective_start;
      if (!startDate) return;

      const date = getDateFormatted(startDate, 'DD/MM/YYYY').toString();
      const normalizedType = (slot.type || 'AVAILABLE').toUpperCase();
      if (date === day) {
        daySlots.push({
          id: slot.id,
          startDate: startDate,
          endDate: slot.end || slot.effective_end,
          isAvailable: normalizedType === 'AVAILABLE' || normalizedType === 'PRIORITY',
          type: normalizedType,
          socialReferents: slot.available_social_referents || [],
          originalStart: slot.start,
          originalEnd: slot.end,
          originalEffectiveStart: slot.effective_start,
          originalEffectiveEnd: slot.effective_end,
          originalAvailableSocialReferents: slot.available_social_referents || []
        });
      }
    });

    return daySlots;
  };

  const formatDay = ({ day }: { day: string }) => {
    const dateObject = getJSDate(day);

    return (
      <ScheduleDay
        dayClassName="flex place-content-center"
        containerClassName="w-full flex gap-2 justify-center items-end uppercase font-semibold"
        dayNumberClassName="font-semibold text-2xl"
        day={dateObject}
      />
    );
  };

  const schedule = useMemo(() => {
    const workDays = getWorkDays(slots);

    const slotDays = workDays.map((day) => {
      const daySlots = getDaySlots(slots, day);

      return {
        day: formatDay({ day }),
        daySlots,
      };
    });

    return splitArray(slotDays);
  }, [slots]);

  return schedule;
};